var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicrosoft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 85.1 80",
    style: {
      enableBackground: "new 0 0 85.1 80"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "testimonial",
    d: "M15.6,13h25.7v25.7H15.6V13z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "testimonial",
    d: "M43.8,13h25.7v25.7H43.8V13z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "testimonial",
    d: "M15.6,41.3h25.7V67H15.6V41.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "testimonial",
    d: "M43.8,41.3h25.7V67H43.8V41.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosoft);
export default __webpack_public_path__ + "static/media/microsoft.94ec874b18851b24bd130185e3121211.svg";
export { ForwardRef as ReactComponent };